export default {
    // Landing page OAuth (legacy)
    baseURL: import.meta.env.VUE_APP_AUTH_BASE_URL,
    redirect_uri: import.meta.env.VUE_APP_AUTH_REDIRECT_URL,
    client_id: import.meta.env.VUE_APP_AUTH_CLIENT_ID,
    response_type: 'token',
    scope: '*',

    // API OAuth (new)
    api: {
        baseURL: `${import.meta.env.VUE_APP_API_BASE_URL}/oauth`,
        redirect_uri: `${import.meta.env.VUE_APP_URL}/oauth/callback`,
        client_id: import.meta.env.VUE_APP_AUTH_CLIENT_ID_NEW,
        response_type: 'code',
        scope: '*',
    },
}
